import axiosClient from "../axiosClient";
import {
  CACHE_KEYS,
  SESSION_CACHE_TTL,
  cachedRequest,
  invalidateCachedRequest,
} from "../../utils/apiCache";

export function index() {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  return axiosClient.get("/user");
}

export function getProfile(options = {}) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  return cachedRequest(
    CACHE_KEYS.userProfile,
    () => axiosClient.get("/user/profile"),
    { ttl: SESSION_CACHE_TTL, force: options.force === true },
  );
}

export function editProfile(data) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;
  invalidateCachedRequest(CACHE_KEYS.userProfile);
  invalidateCachedRequest(CACHE_KEYS.userInfo);
  return axiosClient.post("/user/profile/complete", JSON.stringify(data));
}

// Gets the logged-in user's information from the backend using the access token.
export function getUserInfo(options = {}) {
  let bearerTokenHeader = sessionStorage.getItem("accessToken");
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${bearerTokenHeader}`;

  return cachedRequest(
    CACHE_KEYS.userInfo,
    () => axiosClient.get("/ga-fps/getUserInfo"),
    { ttl: SESSION_CACHE_TTL, force: options.force === true },
  );
}
